<template>
  <component :is="physician === null ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      v-if="physician === null"
      variant="danger"
    >
      <h4 class="alert-heading">
        Erro ao buscar dados do usuário
      </h4>
      <div class="alert-body">
        Nenhum registro encontrado com este ID. Verificar
        <b-link
          class="alert-link"
          :to="{ name: 'physician-list'}"
        >
          Lista de usuários
        </b-link>
        para outros usuários.
      </div>
    </b-alert>

    <b-overlay
      :show="loading"
      variant="light"
      opacity="0.3"
      blur="5px"
      rounded="sm"
    >
      <div v-if="physician !== null" class="physician-form">
        <b-row>
          <b-col cols="12" md="12" class="mb-1">
            <b-alert
              v-model="showAlertValidate"
              v-height-fade.appear
              variant="warning"
              class="mb-0"
            >
              <div class="alert-body">
                <feather-icon
                  icon="AlertTriangleIcon"
                  size="18"
                />
                Aguardando aprovaçao da Imediato
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <validation-observer ref="refFormObserver" #default="{ handleSubmit }">
          <b-form
            @submit.prevent="alertTabError();handleSubmit(save);"
          >
            <b-tabs
              pills
              class="g-med-tabs"
            >
              <b-tab class="g-med-tab" active @click="tabPersonError = false">
                <template #title>
                  <div>
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                      class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Pessoal</span>
                    <feather-icon
                      :class="{'error-icon-show': tabPersonError}"
                      icon="AlertCircleIcon"
                      size="16"
                      class="error-icon text-danger"
                    />
                  </div>
                </template>

                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Nome completo*" label-for="nome">
                      <validation-provider
                        #default="{ errors }"
                        name="nome"
                        vid="nome"
                        rules="required"
                      >
                        <b-form-input id="nome" v-model="physician.name" disabled />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="E-mail*" label-for="email">
                      <validation-provider
                        #default="{ errors }"
                        name="email"
                        vid="email"
                        rules="required"
                      >
                        <b-form-input id="email" v-model="physician.email" disabled />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="Telefone" label-for="telefone">
                      <validation-provider
                        #default="{ errors }"
                        name="telefone"
                        vid="telefone"
                        rules="required"
                      >
                        <cleave
                          id="telefone"
                          v-model="physician.phone"
                          class="form-control"
                          :raw="false"
                          :options="physician.phone.length > 14 ? options.phoneWith9 : options.phone"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <validation-provider
                      #default="validationContext"
                      name="Nascimento"
                      vid="birthday"
                      rules="required"
                    >
                      <b-form-group label="Nascimento" label-for="birthday" :state="getValidationState(validationContext)">
                        <b-form-group>
                          <flat-pickr
                            id="birthday-datepicker"
                            v-model="birthday"
                            class="form-control"
                            :config="dateConfig"
                            @on-change="changeBirthday"
                          />
                        </b-form-group>
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="CPF*" label-for="cpf">
                      <validation-provider
                        #default="{ errors }"
                        name="cpf"
                        vid="cpf"
                        rules="required"
                      >
                        <cleave
                          v-model="physician.cpf"
                          disabled
                          class="form-control"
                          :raw="false"
                          :options="options.customDelimiter"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col cols="6" lg="4">
                        <b-form-group label="Nº Registro" label-for="crm">
                          <validation-provider
                            #default="{ errors }"
                            name="crm"
                            vid="crm"
                            rules="required"
                          >
                            <b-form-input id="crm" v-model="physician.crm" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" lg="4">
                        <b-form-group label="Estado do Registro" label-for="state_id">
                          <b-form-select
                            v-model="physician.state_id"
                            :options="crmStateOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" lg="4">
                        <b-form-group label="Profissão" label-for="profession_id">
                          <v-select
                            v-model="physician.profession_id"
                            disabled
                            :options="professionOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            input-id="value"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <div>
                      <label for="textarea-default">
                        <b-form-checkbox
                          v-model="physician.schedule_restriction"
                          name="schedule-restriction"
                          class="custom-control-danger"
                          switch
                          inline
                          @change="changeRestriction"
                        >
                          Com restrição?
                        </b-form-checkbox>
                      </label>
                      <b-form-textarea
                        id="textarea-default"
                        v-model="physician.schedule_restriction_reason"
                        :disabled="!physician.schedule_restriction"
                        placeholder="Descrição da restrição"
                        rows="3"
                      />
                    </div>
                  </b-col>
                </b-row>
                <hr>
                <b-tabs
                  pills
                >
                  <b-tab active>
                    <template #title>
                      <div>
                        <feather-icon
                          icon="UsersIcon"
                          size="16"
                          class="mr-0 mr-sm-50"
                        />
                        <span class="d-none d-sm-inline">CNPJ Vinculado</span>
                      </div>
                    </template>
                    <b-row>
                      <b-col id="add-company" cols="12" class="d-flex justify-content-between align-items-center justify-content-center mb-1">
                        <div class="flex-grow-1 text-right">
                          <b-button
                            title="Adicionar CNPJ"
                            variant="primary"
                            size="sm"
                            :disabled="physician.need_validate_manually"
                            @click="addCompany()"
                          >
                            Adicionar CNPJ
                          </b-button>
                        </div>
                      </b-col>
                      <b-col>
                        <b-table
                          ref="refWorkplaceListTable"
                          class="position-relative companies-table"
                          :items="physician.companies"
                          responsive
                          :fields="tableColumns"
                          primary-key="id"
                          show-empty
                          empty-text="Não possui CNPJ vinculados"
                        >
                          <template #cell(company)="{ item }">
                            <div :class="{deleted: item.deleted}">
                              <strong>{{ item.name }}</strong>
                              <div>{{ formatCnpj(item.cnpj) }}</div>
                              <div v-if="item.partner_qualification && item.partner_qualification.id">
                                {{ item.partner_qualification.id }} - {{ item.partner_qualification.description }}
                              </div>
                            </div>
                          </template>
                          <template #cell(active)="{ item }">
                            <b-badge
                              pill
                              :variant="item.active ? 'light-success' : 'light-secondary'"
                            >
                              {{ item.active ? 'Ativo' : 'Inativo' }}
                            </b-badge>
                          </template>
                          <template #cell(validation_status)="{ item }">
                            <b-badge
                              v-if="validationStatusMap[item.validation_status]"
                              pill
                              :variant="validationStatusMap[item.validation_status].variant"
                            >
                              {{ validationStatusMap[item.validation_status].label }}
                            </b-badge>
                          </template>
                          <template #cell(motive_need_validate_manually)="{ item }">
                            <div :class="{deleted: item.deleted}">
                              {{ (item.validation_status !== 'validated' && item.motive_need_validate_manually) || '-' }}
                            </div>
                          </template>
                          <template #cell(actions)="data">
                            <b-dropdown
                              variant="link"
                              no-caret
                              :disabled="data.item.deleted"
                            >
                              <template #button-content>
                                <feather-icon
                                  icon="MoreVerticalIcon"
                                  size="16"
                                  class="align-middle text-body"
                                />
                              </template>
                              <b-dropdown-item
                                @click="removeCompany(data.index)"
                              >
                                <div v-if="data.item.active">
                                  <feather-icon icon="XIcon" />
                                  <span class="align-middle ml-50">
                                    Desativar
                                  </span>
                                </div>
                                <div v-else>
                                  <feather-icon icon="CheckIcon" />
                                  <span class="align-middle ml-50">
                                    Ativar
                                  </span>
                                </div>
                              </b-dropdown-item>
                              <b-dropdown-item
                                v-if="data.item.physician_company_id"
                                @click="addAttorney(data.item)"
                              >
                                <feather-icon icon="FilePlusIcon" />
                                <span class="align-middle ml-50">
                                  Adicionar Procuração
                                </span>
                              </b-dropdown-item>
                              <b-dropdown-item
                                v-if="data.item.physician_company_id"
                                @click="showAttorneyHistory(data.item)"
                              >
                                <feather-icon icon="ClockIcon" />
                                <span class="align-middle ml-50">
                                  Histórico de Procurações
                                </span>
                              </b-dropdown-item>
                            </b-dropdown>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <div>
                        <feather-icon
                          icon="ClockIcon"
                          size="16"
                          class="mr-0 mr-sm-50"
                        />
                        <span class="d-none d-sm-inline">
                          Histórico
                        </span>
                      </div>
                    </template>
                    <b-row>
                      <b-col>
                        <b-table
                          ref="refWorkplaceListTable"
                          class="position-relative"
                          :items="historyAddCompanies"
                          responsive
                          :fields="tableHistoryColumns"
                          primary-key="id"
                          show-empty
                          empty-text="Não possui registros"
                        >
                          <template #cell(physician)="{ item }">
                            <strong>{{ item.physician.name }}</strong>
                            <div>{{ formatCpf(item.physician.cpf) }}</div>
                          </template>
                          <template #cell(company)="{ item }">
                            <template v-if="item.company_passed">
                              <strong>{{ item.company_passed.name }}</strong>
                              <div>{{ formatCnpj(item.company_passed.cnpj) }}</div>
                            </template>
                          </template>
                          <template #cell(status)="{ item }">
                            <b-badge
                              pill
                              :variant="historyStatusMap[item.status] ? historyStatusMap[item.status].variant : 'light-secondary'"
                            >
                              {{ historyStatusMap[item.status] ? historyStatusMap[item.status].label : item.status }}
                            </b-badge>
                          </template>
                          <template #cell(actions)="{ item }">
                            <b-button
                              variant="outline-primary"
                              size="sm"
                              class="action"
                              @click="showDetail(item)"
                            >
                              <feather-icon
                                size="16"
                                icon="EyeIcon"
                              />
                            </b-button>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>

              </b-tab>
            </b-tabs>
            <b-row class="mt-3">
              <b-col cols="12" md="4">
                <b-button
                  variant="primary"
                  class="mt-1 mr-1"
                  type="submit"
                  :disabled="showAlertValidate"
                >
                  Salvar
                </b-button>

              </b-col>
              <b-col cols="12" md="8">
                <p class="text-danger m-0 mt-2 text-right">
                  <b>*</b>Para alterar Nome, E-mail e CPF entre em contato com a <b>IMEDIATO</b>.
                </p>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-overlay>

    <b-modal
      id="modal-company"
      ref="addCompanyModal"
      centered
      hide-footer
      title="Adicionar CNPJ"
    >
      <b-overlay
        :show="loading"
        variant="light"
        opacity="0.3"
        blur="5px"
        rounded="sm"
      >
        <b-alert
          v-model="showAlert"
          v-height-fade.appear
          variant="danger"
          dismissible
          class="mb-0"
        >
          <div class="alert-body">
            <ul class="m-0">
              <li v-for="(message, index) of alertMessage" :key="index">
                {{ message }}
              </li>
            </ul>
          </div>
        </b-alert>
        <validation-observer
          ref="refFormCompanyObserver"
          #default="{ handleSubmit }"
        >
          <b-form @submit.prevent="handleSubmit(saveCompany)">
            <b-form-group
              label="CNPJ"
              label-for="company-cnpj"
            >
              <validation-provider
                #default="{ errors }"
                name="CNPJ"
                vid="cnpj"
                rules="cnpj|required"
              >
                <cleave
                  id="cnpj"
                  v-model="company.cnpj"
                  class="form-control"
                  :raw="false"
                  :options="options.cnpjDelimiter"
                  :disabled="!company.can_update"
                  @keydown.native="onCnpjKeydown"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small v-if="company.cnpj && validCompanies[company.cnpj] && validCompanies[company.cnpj].length > 1" class="text-danger">CNPJ {{ company.cnpj }} duplicado</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Razão Social" label-for="company-name">
              <validation-provider
                #default="{ errors }"
                name="Razão Social"
                vid="company-name"
                rules="required"
              >
                <b-form-input id="company-name" v-model="company.name" :disabled="!company.can_update" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Procuração"
              label-for="attorney-file"
            >
              <b-form-file
                id="attorney-file"
                v-model="company.attorney_file"
                placeholder="Escolha um arquivo..."
                drop-placeholder="Solte o arquivo aqui..."
                browse-text="Selecionar"
                :accept="attorneyFileAccept"
                :state="attorneyFileError ? false : null"
              />
              <small class="text-body d-block">Caso não seja sócio administrador, anexar procuração.</small>
              <small class="text-muted d-block">Formatos: PDF, JPG, JPEG, PNG, DOC, DOCX. Máximo de 15MB.</small>
              <small v-if="attorneyFileError" class="text-danger">{{ attorneyFileError }}</small>
            </b-form-group>
            <div class="text-right">
              <b-button
                v-if="showSaveWithReservation"
                variant="danger"
                class="mt-1 mr-1"
                type="submit"
                @click="company.need_validate_manually = true"
              >
                Salvar com ressalva
              </b-button>
              <b-button
                variant="primary"
                class="mt-1"
                type="submit"
                @click="company.need_validate_manually = false"
              >
                Salvar
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>

    <b-modal
      id="modal-company-attorney"
      ref="addAttorneyModal"
      centered
      hide-footer
      title="Adicionar Procuração"
    >
      <b-overlay
        :show="loading"
        variant="light"
        opacity="0.3"
        blur="5px"
        rounded="sm"
      >
        <b-form @submit.prevent="saveAttorney">
          <div v-if="attorneyCompany" class="mb-1">
            <strong>{{ attorneyCompany.name }}</strong>
            <div>{{ formatCnpj(attorneyCompany.cnpj) }}</div>
          </div>
          <b-form-group
            label="Procuração"
            label-for="company-attorney-file"
          >
            <b-form-file
              id="company-attorney-file"
              v-model="attorneyFile"
              placeholder="Escolha um arquivo..."
              drop-placeholder="Solte o arquivo aqui..."
              browse-text="Selecionar"
              :accept="attorneyFileAccept"
              :state="attorneyUploadError ? false : null"
            />
            <small class="text-muted d-block">Formatos: PDF, JPG, JPEG, PNG, DOC, DOCX. Máximo de 15MB.</small>
            <small v-if="attorneyUploadError" class="text-danger">{{ attorneyUploadError }}</small>
          </b-form-group>
          <div class="text-right">
            <b-button
              variant="primary"
              class="mt-1"
              type="submit"
              :disabled="!attorneyFile || !!attorneyUploadError"
            >
              Salvar
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-modal>

    <b-modal
      id="modal-company-attorney-history"
      ref="attorneyHistoryModal"
      size="xl"
      centered
      hide-footer
      title="Histórico de Procurações"
    >
      <div v-if="attorneyHistoryCompany">
        <div class="mb-1">
          <strong>{{ attorneyHistoryCompany.name }}</strong>
          <div>{{ formatCnpj(attorneyHistoryCompany.cnpj) }}</div>
        </div>
        <b-table
          class="position-relative"
          :items="attorneyHistoryCompany.attorneys || []"
          responsive
          :fields="tableAttorneyColumns"
          primary-key="id"
          show-empty
          empty-text="Não possui procurações"
        >
          <template #cell(file_name)="{ item }">
            <b-link
              v-if="item.file_url"
              :href="item.file_url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.file_name }}
            </b-link>
            <span v-else>{{ item.file_name || '-' }}</span>
          </template>
          <template #cell(status)="{ item }">
            <b-badge
              pill
              :variant="attorneyStatusMap[item.status] ? attorneyStatusMap[item.status].variant : 'light-secondary'"
            >
              {{ attorneyStatusMap[item.status] ? attorneyStatusMap[item.status].label : item.status }}
            </b-badge>
          </template>
          <template #cell(sent_at)="{ item }">
            {{ formatAttorneyDate(item.sent_at, 'dd/MM/yyyy HH:mm') }}
          </template>
          <template #cell(reviewed_at)="{ item }">
            {{ formatAttorneyDate(item.reviewed_at, 'dd/MM/yyyy HH:mm') }}
          </template>
          <template #cell(expires_at)="{ item }">
            {{ formatAttorneyDate(item.expires_at, 'dd/MM/yyyy') }}
          </template>
          <template #cell(review_justification)="{ item }">
            {{ item.review_justification || '-' }}
          </template>
        </b-table>
      </div>
    </b-modal>

    <b-modal
      id="modal-company-history"
      ref="addCompanyModalHistory"
      size="lg"
      centered
      hide-footer
      title="Detalhes"
    >
      <div v-if="currentHistoryItem.company">
        <h5>Sócios e Administradores</h5>
        <table class="mb-1 mt-2 mt-xl-0 w-100">
          <tr>
            <th>
              <span class="font-weight-bold">CPF/CNPJ</span>
            </th>
            <th class="px-1">
              <span class="font-weight-bold">Tipo</span>
            </th>
            <th>
              <span class="font-weight-bold">Nome</span>
            </th>
          </tr>
          <tr v-for="(partner, i) in currentHistoryItem.company.partners" :key="i">
            <td>{{ partner.cpf_cnpj.length > 10 ? formatCnpj(partner.cpf_cnpj) : formatCpf(partner.cpf_cnpj) }}</td>
            <td class="px-1 text-truncate">
              {{ partner.qualification }}
            </td>
            <td class="w-100">
              {{ partner.name }}
            </td>
          </tr>
        </table>
      </div>
    </b-modal>
  </component>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BModal,
  BFormDatepicker,
  BTab,
  BTabs,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BFormSelect,
  BButton,
  BLink,
  BAlert,
  BFormCheckbox,
  BFormTextarea,
  BInputGroupAppend,
  BInputGroup, BMedia, BTable, BDropdownItem, BDropdown, BBadge, BFormInvalidFeedback, BOverlay, BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { sortBy } from 'lodash'
import Cleave from 'vue-cleave-component'
import store from '@/store'
import {
  computed, onMounted, onUnmounted, ref, watch,
} from '@vue/composition-api'
import Fuse from 'fuse.js'
import groupBy from 'lodash/groupBy'
import { required } from '@validations'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import {
  format, isValid, parse, parseISO,
} from 'date-fns'
import formError from '@core/comp-functions/forms/form-error'
import formValidation from '@core/comp-functions/forms/form-validation'
import Vue from 'vue'
import { formatCnpj, formatCpf } from '@core/utils/utils'
import { getCnpjCleaveOptions, onCnpjKeydown } from '@core/utils/cnpj-cleave-options'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import physicianStoreModule from '../physicianStoreModule'

export default {
  components: {
    BFormFile,
    BOverlay,
    BModal,
    BFormInvalidFeedback,
    BBadge,
    BDropdown,
    BDropdownItem,
    BTable,
    BMedia,
    flatPickr,
    BInputGroupAppend,
    BInputGroup,
    BTab,
    BTabs,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BFormSelect,
    BButton,
    BLink,
    BAlert,
    BFormCheckbox,
    BFormTextarea,
    Cleave,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
  },
  directives: {
    'height-fade': heightFade,
    Ripple,
  },
  data() {
    return {
      dateConfig: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
      },
      options: {
        cnpjDelimiter: getCnpjCleaveOptions(),
        customDelimiter: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 2],
          numericOnly: true,
        },
        phone: {
          delimiters: ['(', ')', ' ', '-'],
          blocks: [0, 2, 0, 4, 5],
          numericOnly: true,
          delimiterLazyShow: true,
        },
        phoneWith9: {
          delimiters: ['(', ')', ' ', '-'],
          blocks: [0, 2, 0, 5, 4],
          numericOnly: true,
          delimiterLazyShow: true,
        },
        number: {
          numeralPositiveOnly: true,
          numericOnly: true,
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          prefix: 'R$ ',
          rawValueTrimPrefix: true,
        },
        income: {
          numeralPositiveOnly: true,
          numericOnly: true,
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          prefix: 'R$ ',
          rawValueTrimPrefix: true,
        },
        postalCode: {
          delimiters: ['-'],
          blocks: [5, 3],
          numericOnly: true,
        },
      },
    }
  },
  methods: { formatCpf, onCnpjKeydown },
  setup() {
    const PHYSICIAN_APP_STORE_MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(PHYSICIAN_APP_STORE_MODULE_NAME)) store.registerModule(PHYSICIAN_APP_STORE_MODULE_NAME, physicianStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PHYSICIAN_APP_STORE_MODULE_NAME)) store.unregisterModule(PHYSICIAN_APP_STORE_MODULE_NAME)
    })

    const toast = useToast()

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(() => {})

    const COMPANY_WITHOUT_PARTNERS_ERROR_CODE = 20260911120000
    const ATTORNEY_REQUIRED_ERROR_CODE = 20260921120000
    const ADMINISTRATIVE_PARTNER_REQUIRED_ERROR_CODE = 20261013120000
    const ATTORNEY_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx']
    const ATTORNEY_FILE_MAX_SIZE = 15 * 1024 * 1024
    const attorneyFileAccept = ATTORNEY_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',')

    const company = ref({})
    const showAlert = ref(false)
    const showAlertValidate = ref(false)
    const showSaveWithReservation = ref(false)
    const alertMessage = ref([])
    const resetCompany = () => {
      company.value = {
        cnpj: '',
        name: '',
        can_update: true,
        active: true,
        deleted: false,
        need_validate_manually: false,
        attorney_file: null,
      }
    }

    const getAttorneyFileError = file => {
      if (!file) return null
      const extension = file.name.split('.').pop().toLowerCase()
      if (!ATTORNEY_FILE_EXTENSIONS.includes(extension)) {
        return 'Formato inválido. Permitidos: PDF, JPG, JPEG, PNG, DOC, DOCX.'
      }
      if (file.size > ATTORNEY_FILE_MAX_SIZE) {
        return 'O arquivo deve ter no máximo 15MB.'
      }
      return null
    }
    const attorneyFileError = computed(() => getAttorneyFileError(company.value.attorney_file))
    resetCompany()
    const refFormCompanyObserver = ref(null)
    const addCompanyModal = ref(null)
    const addAttorneyModal = ref(null)
    const attorneyCompany = ref(null)
    const attorneyFile = ref(null)
    const attorneyUploadError = computed(() => getAttorneyFileError(attorneyFile.value))
    const attorneyHistoryModal = ref(null)
    const attorneyHistoryCompany = ref(null)
    const isNew = ref(!!router.currentRoute.query.new)
    const isNewValidated = ref(router.currentRoute.query.validated)
    const birthday = ref(null)
    const tabPersonError = ref(false)
    const tabBankError = ref(false)
    const tabAddressError = ref(false)
    const physician = ref(null)
    const postalCode = ref('')
    const stateId = ref(null)
    const cityId = ref(null)
    const street = ref('')
    const number = ref('')
    const complement = ref('')
    const neighborhood = ref('')
    const loading = ref(false)

    const historyAddCompanies = ref([])
    const currentHistoryItem = ref({})
    const addCompanyModalHistory = ref(null)

    const states = ref([])
    const stateOptions = ref([])
    const crmStateOptions = ref([])
    const professionOptions = ref([])
    const cities = ref([])
    const cityOptions = ref([])
    const financialInstitutionId = ref('')
    const accountType = ref('')
    const bankOptions = ref([])
    const accountTypes = ref([
      {
        value: 'savings_account',
        text: 'Poupança',
      },
      {
        value: 'checking_account',
        text: 'Corrente',
      },
    ])
    const tableColumns = [
      { key: 'company', label: 'Empresa' },
      { key: 'active', label: 'Status' },
      { key: 'validation_status', label: 'Ativação Manual?' },
      { key: 'motive_need_validate_manually', label: 'Motivo' },
      { key: 'actions', label: 'Ações' },
    ]

    const validationStatusMap = {
      validated: { label: 'Validado', variant: 'light-success' },
      pending: { label: 'Aguardando aprovação', variant: 'light-warning' },
      denied: { label: 'Negado', variant: 'light-danger' },
    }

    const tableAttorneyColumns = [
      { key: 'file_name', label: 'Arquivo' },
      { key: 'status', label: 'Status' },
      { key: 'sent_at', label: 'Enviado em' },
      { key: 'reviewed_at', label: 'Revisado em' },
      { key: 'expires_at', label: 'Validade' },
      { key: 'review_justification', label: 'Justificativa' },
    ]

    const attorneyStatusMap = {
      approved: { label: 'Aprovada', variant: 'light-success' },
      pending: { label: 'Aguardando aprovação', variant: 'light-warning' },
      denied: { label: 'Negada', variant: 'light-danger' },
    }

    const historyStatusMap = {
      pending_approval: { label: 'Aguardando aprovação', variant: 'light-warning' },
      attorney_pending: { label: 'Procuração pendente', variant: 'light-warning' },
      attorney_approved: { label: 'Procuração aprovada', variant: 'light-success' },
      attorney_denied: { label: 'Procuração negada', variant: 'light-danger' },
      approved: { label: 'Aprovado', variant: 'light-success' },
      denied: { label: 'Negado', variant: 'light-danger' },
      associated: { label: 'Vinculado', variant: 'light-success' },
      failed: { label: 'Falhou', variant: 'light-danger' },
    }

    const formatAttorneyDate = (value, pattern) => {
      if (!value) return '-'
      const date = parseISO(value)
      return isValid(date) ? format(date, pattern) : value
    }

    const tableHistoryColumns = [
      { key: 'physician', label: 'Profissional' },
      { key: 'company', label: 'Empresa' },
      { key: 'status', label: 'Status' },
      { key: 'message', label: 'Mensagem' },
      { key: 'actions', label: 'Ações' },
    ]

    const tabsMap = {
      cpf: tabPersonError,
      bank: tabBankError,
      nome: tabPersonError,
      email: tabPersonError,
      telefone: tabPersonError,
      crm: tabPersonError,
      birthday: tabPersonError,
    }

    const validCompanies = computed(() => {
      if (physician.value?.companies.length) {
        return groupBy(physician.value?.companies, 'cnpj')
      }
      return {}
    })

    function isValidDate(d) {
      return d instanceof Date && !Number.isNaN(d)
    }

    function addCompany() {
      alertMessage.value = []
      showAlert.value = false
      showSaveWithReservation.value = false
      resetCompany()
      addCompanyModal.value.show()
    }

    function removeCompany(index) {
      if (physician.value.companies[index]) {
        physician.value.companies[index].active = !physician.value.companies[index].active
      }
    }

    async function alertTabError() {
      tabPersonError.value = false
      tabBankError.value = false
      tabAddressError.value = false

      const isBirthdayError = !(typeof (birthday.value) === 'string' && /\//.test(birthday.value)) && (birthday.value === null || !isValidDate(birthday.value))
      if (isBirthdayError) tabPersonError.value = true
      await refFormObserver.value.validate()
      const { errors } = refFormObserver.value
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const field in errors) {
        if (errors[field].length > 0 && tabsMap[field]) {
          tabsMap[field].value = true
        }
      }
      if (isBirthdayError) refFormObserver.value.setErrors({ birthday: ['O campo nascimento é obrigatório.'] })
    }

    const fetchCities = ({ stateId: state }) => store.dispatch(`${PHYSICIAN_APP_STORE_MODULE_NAME}/fetchCities`, {
      stateId: state,
    }).then(resp => {
      cities.value = resp.data
      cityOptions.value = resp.data.map(city => ({
        value: city.id,
        text: city.name,
      }))
    })
    const getAddressByZipCode = zipCode => store.dispatch(`${PHYSICIAN_APP_STORE_MODULE_NAME}/getAddressByZipCode`, { zipCode })
    const getState = stateCode => states.value.find(s => s.abbreviation === stateCode)
    const changePostalCode = code => {
      if (code.length === 9) {
        getAddressByZipCode(code)
          .then(async data => {
            const state = getState(data.state)
            await fetchCities({ stateId: state.id })
            const city = cities.value.find(c => c.name === data.city)
            street.value = data.street
            neighborhood.value = data.neighborhood
            complement.value = data.complement
            cityId.value = city.id
            stateId.value = state.id
          })
      }
    }

    watch(postalCode, postalCodeCurrent => {
      if (!loading.value) {
        changePostalCode(postalCodeCurrent)
      }
    })

    const fetchStates = () => {
      store.dispatch(`${PHYSICIAN_APP_STORE_MODULE_NAME}/fetchStates`, {})
        .then(resp => {
          const stts = sortBy(resp.data, ['abbreviation'])
          states.value = stts
          stateOptions.value = stts.map(state => ({
            value: state.id,
            text: state.name,
          }))
          crmStateOptions.value = stts.map(state => ({
            value: state.id,
            text: state.abbreviation,
          }))
        })
    }
    fetchStates()

    const fetchProfessions = () => store.dispatch(`${PHYSICIAN_APP_STORE_MODULE_NAME}/fetchProfessions`)
      .then(response => {
        const options = response.data.data.map(p => ({
          label: p.label,
          value: p.id,
        }))
        if (physician.value.profession) {
          const { profession } = physician.value
          const found = options.find(p => p.value === profession.id)
          if (!found) {
            options.push({
              label: profession.label,
              value: profession.id,
            })
          }
        }
        professionOptions.value = options
        physician.value.profession_id = physician.value.profession.id
      })

    function updateBankId() {
      if (financialInstitutionId.value) {
        physician.value.account.financial_institution_id = financialInstitutionId.value.value
      } else {
        physician.value.account.financial_institution_id = null
      }
    }

    loading.value = true
    const refetchCompanies = () => {
      loading.value = true
      store.dispatch('app-physician/fetchPhysician', { id: router.currentRoute.params.id })
        .then(async ({ data }) => {
          const physicianData = data.data
          physician.value.companies = physicianData.companies.map(p => ({
            ...p,
            deleted: false,
          }))
        })
        .finally(() => {
          loading.value = false
        })
    }
    store.dispatch('app-physician/fetchPhysician', { id: router.currentRoute.params.id })
      .then(async ({ data }) => {
        const physicianData = data.data

        if (physicianData.need_validate_manually) {
          showAlertValidate.value = true
        }

        birthday.value = parse(physicianData.birthday, 'yyyy-MM-dd', new Date())
        physician.value = {
          ...physicianData,
          companies: physicianData.companies.map(p => ({
            ...p,
            deleted: false,
          })),
          account: physicianData.account ?? { },
          state_id: physicianData.state.id,
        }
        if (physicianData.profession) {
          fetchProfessions().then(() => {
            // physician.value.profession_id = physicianData.profession[0].id
          })
        }

        if (physicianData.address.postal_code) {
          postalCode.value = physicianData.address.postal_code
          street.value = physicianData.address.street
          number.value = physicianData.address.number
          neighborhood.value = physicianData.address.neighborhood
          complement.value = physicianData.address.complement
          stateId.value = physicianData.address.city.state.id
          await fetchCities({ stateId: stateId.value })
          cityId.value = physicianData.address.city.id
        }

        loading.value = false
      })
      .catch(error => {
        if (error.response.status === 404) {
          physician.value = undefined
        }
      })

    const fetchPhysicianHistoryAddCompany = () => {
      store.dispatch('app-physician/fetchPhysicianHistoryAddCompany', { id: router.currentRoute.params.id })
        .then(async ({ data }) => {
          historyAddCompanies.value = data.data
        })
    }
    fetchPhysicianHistoryAddCompany()

    function showDetail(historyItem) {
      currentHistoryItem.value = historyItem
      addCompanyModalHistory.value.show()
    }

    function filterFinancialInstitutions(options, search) {
      const fuse = new Fuse(options, {
        keys: ['label'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    }

    function alertError(message) {
      Vue.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Erro',
          icon: 'XOctagonIcon',
          variant: 'danger',
          text: message,
        },
      })
    }

    const save = () => {
      const cnpjs = Object.keys(validCompanies.value)
      // eslint-disable-next-line no-restricted-syntax
      for (const cnpj of cnpjs) {
        if (validCompanies.value[cnpj].length > 1) {
          alertError('CNPJ duplicados')
          return
        }
      }

      physician.value.companies = physician.value.companies.filter(c => !c.deleted)
      const { account, ...data } = physician.value

      if (data.birthday && !/^\d{4}-\d{2}-\d{2}$/.test(data.birthday)) {
        alertError('Nascimento formato inválido')
        return
      }

      const body = {
        ...data,
      }
      loading.value = true
      store.dispatch(`${PHYSICIAN_APP_STORE_MODULE_NAME}/updatePhysician`, body)
        .then(() => {
          loading.value = false
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Sucesso',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Profissional atualizado com sucesso',
            },
          })
          router.push('/physician/list')
        })
        .catch(error => {
          loading.value = false
          const { setErrors, getErrorMessage } = formError(refFormObserver.value, error)
          setErrors()
          if (getErrorMessage()) {
            alertError(getErrorMessage())
          }
        })
    }

    function changeRestriction() {
      if (!physician.value.schedule_restriction) {
        physician.value.schedule_restriction_reason = null
      }
    }
    function changeBirthday(birth) {
      if (birth[0]) {
        physician.value.birthday = format(birth[0], 'yyyy-MM-dd')
      } else {
        physician.value.birthday = null
      }
    }

    onMounted(async () => {
      if (isNew.value) {
        router.replace({ query: null })
        let config = {
          title: 'Cadastrado!',
          text: 'Profissional cadastrado com sucesso',
          icon: 'success',
          showCancelButton: true,
          confirmButtonText: 'Cadastrar CNPJ',
          cancelButtonText: 'Sair',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-primary ml-1',
          },
          buttonsStyling: false,
        }
        if (isNewValidated.value === 'true') {
          config = {
            title: 'Cadastrado com ressalvas!',
            text: 'Necessário aprovação da Imediato',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-primary ml-1',
            },
            buttonsStyling: false,
          }
        }
        const result = await Vue.swal(config)
        if (result.isConfirmed
            && (isNewValidated.value === 'false' || !isNewValidated.value)
            && isNew.value) {
          document.getElementById('add-company').scrollIntoView()
        } else {
          router.push('/physician/list')
        }
      }
    })

    function saveCompany() {
      if (attorneyFileError.value) return
      const { id } = router.currentRoute.params
      const cnpj = company.value.cnpj.replace(/\D/g, '')
      loading.value = true
      store.dispatch('app-physician/addCompanyPhysician', { id, ...company.value, cnpj })
        .then(() => {
          loading.value = false
          showSaveWithReservation.value = false
          physician.value.companies.push(company.value)
          addCompanyModal.value.hide()
          resetCompany()
          refetchCompanies()
        })
        .catch(error => {
          loading.value = false
          const errorData = error.response && error.response.data
          const validationStatus = errorData && (errorData.validation_status || (errorData.data && errorData.data.validation_status))
          if (errorData && (errorData.error_code === COMPANY_WITHOUT_PARTNERS_ERROR_CODE || validationStatus === 'pending')) {
            showSaveWithReservation.value = true
            showAlert.value = true
            alertMessage.value = [errorData.message]
            return
          }
          if (errorData && [ATTORNEY_REQUIRED_ERROR_CODE, ADMINISTRATIVE_PARTNER_REQUIRED_ERROR_CODE].includes(errorData.error_code)) {
            showAlert.value = true
            alertMessage.value = [errorData.message]
            return
          }
          if (error.response && error.response.data && [20240719191640].includes(error.response.data.error_code)) {
            showAlert.value = true
            alertMessage.value = error.response.data.message.split('; ')
            // eslint-disable-next-line no-param-reassign
            error.response.data.message = 'Dados inválidos'
          }
          if (error.response) { alertError(error.response.data.message) }
        })
        .finally(() => {
          fetchPhysicianHistoryAddCompany()
        })
    }

    function addAttorney(item) {
      attorneyCompany.value = item
      attorneyFile.value = null
      addAttorneyModal.value.show()
    }

    function saveAttorney() {
      if (!attorneyFile.value || attorneyUploadError.value) return
      loading.value = true
      store.dispatch('app-physician/addCompanyAttorney', {
        physicianCompanyId: attorneyCompany.value.physician_company_id,
        attorneyFile: attorneyFile.value,
      })
        .then(() => {
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Sucesso',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Procuração adicionada com sucesso',
            },
          })
          addAttorneyModal.value.hide()
          attorneyFile.value = null
          refetchCompanies()
        })
        .catch(error => {
          loading.value = false
          const errorData = error.response && error.response.data
          alertError((errorData && errorData.message) || 'Não foi possível adicionar a procuração')
        })
    }

    function showAttorneyHistory(item) {
      attorneyHistoryCompany.value = item
      attorneyHistoryModal.value.show()
    }

    return {
      showAttorneyHistory,
      attorneyHistoryModal,
      attorneyHistoryCompany,
      tableAttorneyColumns,
      attorneyStatusMap,
      historyStatusMap,
      formatAttorneyDate,
      addAttorney,
      saveAttorney,
      addAttorneyModal,
      attorneyCompany,
      attorneyFile,
      attorneyUploadError,
      showAlert,
      showAlertValidate,
      alertMessage,
      birthday,
      changeBirthday,
      stateOptions,
      crmStateOptions,
      states,
      cities,
      cityOptions,
      bankOptions,
      required,
      physician,
      loading,
      postalCode,
      stateId,
      cityId,
      fetchCities,
      street,
      number,
      complement,
      neighborhood,
      save,
      financialInstitutionId,
      filterFinancialInstitutions,
      updateBankId,
      accountType,
      accountTypes,
      changePostalCode,
      tabPersonError,
      tabBankError,
      tabAddressError,
      alertTabError,
      refFormObserver,
      changeRestriction,
      getValidationState,
      addCompany,
      professionOptions,
      removeCompany,
      validCompanies,
      tableColumns,
      tableHistoryColumns,
      validationStatusMap,
      formatCnpj,
      addCompanyModal,
      company,
      saveCompany,
      attorneyFileAccept,
      attorneyFileError,
      showSaveWithReservation,
      refFormCompanyObserver,
      historyAddCompanies,
      showDetail,
      currentHistoryItem,
      addCompanyModalHistory,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.deleted {
  color: #b8c2cc;
  text-decoration: line-through;
}

.companies-table {
  min-height: 260px;
}

.error-icon {
  margin-left: 5px;
  opacity: 0;
}
.error-icon-show {
  opacity: 1;
}
.btn-group {
  height: 38px;
}
fieldset {
  margin-bottom: 0!important;
}
.custom-select:disabled {
  color: #6e6b7b;
  background-color: #efefef!important;
  opacity: 1;
}
.btn-remove {
  margin-top: 1px;
}
</style>
